import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import { SelectElement, useFormContext } from 'react-hook-form-mui';
import { ClearIcon } from '@mui/x-date-pickers/icons';
import { Box } from '@mui/material';

// This component is a wrapper around the SelectElement component from the react-hook-form-mui library.

interface IProps {
    name: string
    value?: string | number | null
    loading?: boolean
    disabled?: boolean
    options: any[]
    readOnly?: boolean
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
    required?: boolean
    label?: string
    hideClearIcon?: boolean
}
export default function ValidatedSelectElement(props: IProps) {

    var { setValue, watch } = useFormContext();
    var value = watch(props.name);

    return (
        <>
            {props.options &&
                <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <SelectElement
                        name={props.name}
                        disabled={props.disabled}
                        onChange={props.onChange}
                        required={props.required}
                        fullWidth={true}
                        options={props.options}
                        value={props.value}
                        size="small"
                        label={props.label}
                        SelectProps={{
                            MenuProps: {
                                PaperProps: {
                                    sx: {
                                        '& .MuiList-root': {
                                            maxHeight: '55vh',

                                        },
                                        scrollbarWidth: 'thin'
                                    }
                                }
                            }
                        }}
                        inputProps={{
                            disabled: props.loading,
                            startAdornment: (
                                !props.loading ? null : <CircularProgress size={20} />
                            ),
                            readOnly: props.readOnly ?? false
                        }}

                    />
                    {(value && !props.readOnly && !props.hideClearIcon) ? (
                        <IconButton
                            size="small"
                            sx={{ ml: 1 }}
                            onClick={() => setValue(props.name, null, { shouldValidate: true })}
                        >
                            <ClearIcon fontSize="small" />
                        </IconButton>
                    )
                        :
                        <></>}
                </Box>
            }
            {!props.options && <SelectElement name={''} />}
        </>
    )

}